import React, { useState } from "react";

/**
 * Împotriva completării automate a browserului (nume de utilizator/parolă salvate care ajung în câmpuri nepotrivite):
 *  - <NoAutofillInput>: câmp „doar citire" până când utilizatorul dă click/Tab în el — browserul nu completează câmpuri
 *    doar-citire; după focalizare se comportă normal (autocomplete="off").
 *  - <AutofillDecoys/>: două câmpuri invizibile (utilizator + parolă) puse ÎNAINTEA câmpurilor reale — dacă browserul
 *    vrea neapărat să completeze un formular de autentificare, o face în ele.
 */
export function NoAutofillInput({ onFocus, readOnly, ...props }) {
  const [armed, setArmed] = useState(false);
  return (
    <input autoComplete="off" {...props} readOnly={readOnly || !armed}
      onFocus={(e) => { e.target.readOnly = false; setArmed(true); onFocus && onFocus(e); }} />
  );
}

export function AutofillDecoys() {
  const hidden = { position: "absolute", left: "-9999px", top: "auto", width: 1, height: 1, opacity: 0, pointerEvents: "none" };
  return (
    <div aria-hidden="true" style={{ position: "relative", height: 0, overflow: "hidden" }}>
      <input type="text" name="username" autoComplete="username" tabIndex={-1} style={hidden} defaultValue="" />
      <input type="password" name="password" autoComplete="current-password" tabIndex={-1} style={hidden} defaultValue="" />
    </div>
  );
}
